import styled from 'styled-components';

export const GanttContainer = styled.div`
  margin-top: 16px;
`;

export const InfoElement = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;

  & > div:not(:last-child) {
    display: flex;
    align-items: center;
    margin-right: 8px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const FormListElements = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const GanttsWrapper = styled.div`
  & > div:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grayVariations.medium};
    margin-bottom: 25px;
    padding-bottom: 25px;
  }
`;
